import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import ContactForm from "./pages/ContactForm";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer";
import Login from "./pages/Login";
//import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
//import ChangePassword from "./pages/ChangePassword";
import Competitions from "./pages/Competitions";
import Events from "./pages/Events";
import Music from "./pages/Music";
import Divisions from "./pages/Divisions";
import Performances from "./pages/Performances";
import JudgeScoreCard from "./pages/JudgeScoreCard";
import { SkeletonTheme } from "react-loading-skeleton";
import Placements from "./pages/Placement";
import EditProfile from "./pages/EditProfile";
import TalkTapePage from "./pages/TalkTape";

//admin modules
import AdminUsers from "./pages/admin/AdminUsers";
import AdminPerformances from "./pages/admin/AdminPerformances";
//import AdminPerformancesUpload from "./pages/admin/AdminPerformancesUpload";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useHideTemplateHeader from "./hooks/useHideTemplateHeader";

const App: React.FC = () => {
  const [modules, setModules] = useState<
    { id: number; title: string; url: string }[]
  >([]);
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);


  useEffect(() => {
    const user = localStorage.getItem("user");
    const token = localStorage.getItem("token");

    if (user && token) {
      const parsedUser = JSON.parse(user);
      setModules(parsedUser.modules);
      setIsLoggedIn(true);
    }
    setIsLoading(false);
  }, []);

  const handleLogin = (
    userModules: { id: number; title: string; url: string }[]
  ) => {
    setIsLoggedIn(true);
    setModules(userModules);
  };

  const handleLogout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
  };

  // Check if the user has access to a module by title (e.g., 'Events')
  const hasAccessToModule = (moduleName: string) => {
  const canViewModule = !!JSON.parse(localStorage.getItem("user") || '{}')?.modules?.find((m:any) => m.title === moduleName)?.ModulesPermissions?.view;
    //console.log(moduleName + " ----- " + canViewModule);
    return canViewModule;
    //return modules.some((module) => module.title === moduleName);
  };

  function capitalize(str: string = ""): string {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  //console.log("App rendering Events")
  const currentRole = JSON.parse(localStorage.getItem("user") || '{}').current_role;
  const currentRoleTitle = capitalize(((JSON.parse(localStorage.getItem("user") || '{}')?.roles?.[0]?.role_name) || ''));
  document.title = "JFK Judging App - " + currentRoleTitle;

  const DefaultDashboard = () => {
    if (isLoading) {
      return null; // Or add a loading spinner if needed
    }
    
    if (!isLoggedIn) {
      return <Navigate to="/login" replace />;
    }
    
    return currentRole === 1 || currentRole === 8 ? (
      <Navigate to="/admin-dashboard" replace />
    ) : (
      <Navigate to="/competitions" replace />
    );
  };

   const hideTemplateHeader = useHideTemplateHeader([
    "/talktape/",  // "/embed/",
  ]);

  return (
    <SkeletonTheme baseColor="#e5d3e7" highlightColor="#e0e0e0">
      <div className="app-container">
        {!hideTemplateHeader && (
          <Navbar
            isLoggedIn={isLoggedIn}
            handleLogout={handleLogout}
            modules={modules}
          />
        )}
        <div className="content">
          <Routes>
        
            <Route path="/" element={<DefaultDashboard />} />
            
            <Route path="/contact" element={<ContactForm />} />
            <Route path="/talktape/:id" element={<TalkTapePage />} />
            <Route path="/login" element={<Login onLogin={handleLogin} />} />
            
            {/* Admin route for main dashboard */}
            {isLoggedIn && (currentRole == "1" || currentRole == '8') && (
              <Route path="/admin-dashboard/" element={<Dashboard />} />  
            )}
            { /*
            {isLoggedIn && (
            <Route path="/change-password" element={<ChangePassword />} />
            )} */ }
            {isLoggedIn && (
            <Route path="/edit-profile" element={<EditProfile />} />
            )}
            {/* Admin route for CRUD users */}
            {isLoggedIn && (currentRole == "1" || currentRole == '8') && (
              <Route path="/admin/users/" element={<AdminUsers />} />
            )}
            {/* Admin route for CRUD competitions 
            {isLoggedIn && (currentRole == "1" || currentRole == "8" || currentRole == "7") && (
              <Route path="/admin/competitions" element={<Competitions />} />
            )} */}
            {/* Admin route for CRUD events
            {isLoggedIn && (currentRole == "1" || currentRole == "8" || currentRole == "7") && (
              <Route
                path="/admin/events/:competition_id"
                element={<Events
                />}
              />
            )} */}
            {/* Admin route for performances CSV and show performances by event_id 
            {isLoggedIn && hasAccessToModule("Performances") && ( */}
            {isLoggedIn && (currentRole == "1" || currentRole == "8" || currentRole == "7" || currentRole == "9") && (
              <Route
                path="/admin/performances/:event_id"
                element={<AdminPerformances />}
              />
            )}
            {/* Admin route for CRUD divisions 
            {isLoggedIn && (currentRole == "1" || currentRole == "8"|| currentRole == "7") && (
              <Route
                path="/admin/divisions/:event_id"
                element={<Divisions />}
              />
            )} */}
            {/*
            {isLoggedIn && currentRole == "1" && (
              <Route
                path="/admin/performances-upload/"
                element={<AdminPerformancesUpload />}
              />
            )} */}

            {isLoggedIn && hasAccessToModule("Placements") && (
              <Route path="/placements/:division_performance_group_id" element={<Placements />} />
            )}
            

            {/* Dashboard route for users other than admin */}
            {isLoggedIn && (
              <Route path="/dashboard/*" element={<Dashboard />} />
            )}
            {/* Competitions route - Check if the user has access to Competitions */}
            {isLoggedIn && hasAccessToModule("Competitions") && (
              <Route path="/competitions" element={<Competitions />} />
            )}
            {/* Events route - Check if the user has access to Events */}
            {isLoggedIn && hasAccessToModule("Events") && (
              <Route path="/events/:competition_id" element={<Events />} />
            )}
            {isLoggedIn && hasAccessToModule("Music") && (
              <Route path="/music/:event_id" element={<Music />} />
            )}
            {/* Divisions route - Check if the user has access to Divisions */}
            {isLoggedIn && hasAccessToModule("Divisions") && (
              <Route path="/divisions/:event_id" element={<Divisions />} />
            )}
            {/* Performances route - Check if the user has access to Performances */}
            {isLoggedIn && hasAccessToModule("Performances") && (
              <Route
                path="/performances/:division_id"
                element={<Performances />}
              />
            )}
            {/* Scorecard route - Check if the user has access to Scorecard */}
            {/*
            {isLoggedIn && hasAccessToModule("Scorecard") && (
              <Route
                path="/scorecard/:performance_id"
                element={<JudgeScoreCard handleLogout={handleLogout} />}
              />
            )}
            */}
            
            {isLoggedIn && hasAccessToModule("Scorecard") && (
              <Route
                path="/scorecard/:performance_id"
                element={<JudgeScoreCard />}
              />
            )}

            <Route
                path="*"
                element={
                  localStorage.getItem("token") ? (<section></section>) : (
                    <Navigate to="/login" replace />
                  )
                }
              />

              </Routes>
          <ToastContainer
            className="custom-toast-info"
            position="top-right"
            autoClose={7000}
            hideProgressBar={false}
            closeOnClick={true}
            pauseOnHover={true}
            draggable={true}
            theme="light"
          />
        </div>
        <Footer />
      </div>
    </SkeletonTheme>
  );
};

const AppWrapper: React.FC = () => (
  <Router>
    <App />
  </Router>
);

export default AppWrapper;
